import React from 'react';
import styled from 'styled-components';
import { Icon, Label } from '../../atoms';
import { Button } from '../Button';

const StyledViewOnlyButton = styled(Button)`
  cursor: default;
  border-radius: 6px;
  & > ${Label} {
    cursor: default;
  }
`;

const ViewOnlyButton = () => (
  <StyledViewOnlyButton secondary>
    <Icon name='eye' displaySize={20} />
    View Only
  </StyledViewOnlyButton>
);

export { ViewOnlyButton };
